import React, { useEffect, useState } from 'react';
type CountdownProps = {
  totalSeconds?: number;
};
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function Countdown({
  totalSeconds = 24 * 60 * 60
}: CountdownProps) {
  const [remaining, setRemaining] = useState(totalSeconds);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const blocks = [{
    value: pad(hours),
    unit: 'hs'
  }, {
    value: pad(minutes),
    unit: 'min'
  }, {
    value: pad(seconds),
    unit: 'seg'
  }];
  return <div className="flex items-center justify-center gap-1.5 sm:gap-3" role="timer" aria-live="off" data-id="element-47" data-mp="10cbt5hb351es">
      {blocks.map((block, index) => <React.Fragment key={block.unit} data-id="element-48" data-mp="15awlyvo0cit7" data-mpi={index}>
          <div className="min-w-[68px] rounded-xl border border-red-500/50 bg-ink-800 px-2 py-3 text-center sm:min-w-[92px] sm:px-5" data-id="element-49" data-mp="y0wtdi1dlqiw">
            <span className="block text-2xl font-extrabold text-red-500 sm:text-4xl" data-id="element-50" data-mp="t12057u4oouo">
              {block.value}
              <span className="text-sm font-bold text-red-400 sm:text-xl" data-id="element-51" data-mp="17qgfcwkdy0hz">
                {block.unit}
              </span>
            </span>
          </div>
          {index < blocks.length - 1 && <span className="text-2xl font-extrabold text-red-500 sm:text-3xl" data-id="element-52" data-mp="f2u8nffv2fqw">
              :
            </span>}
        </React.Fragment>)}
    </div>;
}